<div class="method-container">
  <ng-container *ngFor="let method of paymentMethods; let i = index">
    <div
      *ngIf="method.value === 'wallet' && mode !== 'wallet'"
      class="method-box {{ method.error ? method.errorClass : '' }} {{
        selectedPaymentMethod?.value === 'wallet' ? 'selected' : ''
      }}"
      (click)="paymentMethodSelected(method, i)"
    >
      <div class="method-info">
        <span class="method-name">{{ method.title }}</span>
        <span class="method-desc" *ngIf="method.description">{{
          method.description
        }}</span>
      </div>
      <div class="method-data" *ngIf="method.data">
        <span class="method-data-key">{{ method.data?.key }}</span>
        <span
          class="method-data-value {{ method.data.valueClass }} {{
            method.error ? method.data.errorClass : ''
          }}"
          >{{ method.data?.value }}</span
        >
      </div>
      <div class="method-icon {{ method.iconClass }}">
        <img src="{{ method.icon }}" alt="{{ method.title }} icon" />
      </div>
    </div>
    <mat-radio-group
      [formControl]="gateway"
      class="radio-group"
      *ngIf="method.children?.length > 0"
      (change)="gwGroupChange($event, method)"
    >
      <details
        *ngIf="
          method.title !== 'wallet' &&
          method.expandable &&
          method.children?.length > 0 &&
          ((mode === 'purchase' && method.hasPurchase) ||
            (mode === 'wallet' && method.hasWallet))
        "
        class="expandable-method-box"
        [class.expanded]="method.expanded"
        [class.has-selected-gw]="method.value === selectedPaymentMethod?.value"
        [attr.open]="method.expanded"
      >
        <summary (click)="toggleExpandableMethod(i, $event)">
          <div class="method-info">
            <span class="method-name">{{ method.title }}</span>
            <span class="method-desc" *ngIf="method.description">{{
              method.description
            }}</span>
          </div>
          <img
            class="gw-logo"
            *ngIf="
              method.value === selectedPaymentMethod?.value && gateway.value
            "
            src="{{ gateway.value?.logo }}"
            alt="selected Gateway logo"
          />
          <img
            src="{{
              method.expanded
                ? kingAssets.ChevronUpBlue
                : kingAssets.ChevronDownGrey
            }}"
            alt="{{
              method.expanded ? 'method expanded icon' : 'method collapsed icon'
            }}"
          />
        </summary>
        <div [@expandCollapse]="method.expanded ? 'expanded' : 'collapsed'">
          <hr />

          <ng-container *ngFor="let gw of method.children; let j = index">
            <div
              *ngIf="
                (mode === 'wallet' && gw.gateway.can_use_for_wallet) ||
                (mode === 'purchase' && gw.gateway.can_use_for_purchase)
              "
              class="option-container"
            >
              <mat-radio-button class="radio-button" [value]="gw.gateway">
                <div class="image-co">
                  <img class="image-card" [src]="gw.gateway?.logo" />
                  <h2 class="item-title">{{ gw.gateway?.title }}</h2>
                </div>
              </mat-radio-button>
            </div>
          </ng-container>

          <!-- <div *ngIf="!method.isList && method.children?.length > 0"> -->
          <!-- <div
          class="on-chain-container"
          *ngIf="!method.isList && method.expandable"
        >
          <mat-label> Currency </mat-label>
          <mat-select
            class="payment-method-select"
            [formControl]="currency"
            placeholder="Currency"
          >
            <mat-option
              *ngFor="let currency of currencies"
              [value]="currency.id"
            >
              {{ currency.name }}
            </mat-option>
          </mat-select>
          <mat-label> Network </mat-label>
          <mat-select
            class="payment-method-select"
            [formControl]="network"
            placeholder="Network"
          >
            <mat-option *ngFor="let network of networks" [value]="network.id">
              {{ network.name }}
            </mat-option>
          </mat-select>
        </div> -->
        </div>
      </details>
    </mat-radio-group>
    <div *ngIf="method.error" class="method-error">
      <img src="assets/images/icons/error-triangle-red.svg" alt="error icon" />
      <span>
        {{ method.error }}
      </span>
    </div>
  </ng-container>
</div>
